/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import { ReactNode, createContext, useContext } from 'react';
import { DocumentVersionType, PageType } from '../../algorithm/types';

export type PageChromeContextType = {
  renderHeaderExtras?: (page: PageType) => ReactNode;
  renderHeaderChrome?: (
    page: PageType,
    documentVersion: DocumentVersionType | undefined,
    onEdit: () => void
  ) => ReactNode;
};

const PageChromeContext = createContext<PageChromeContextType>({});

export const PageChromeProvider = PageChromeContext.Provider;

export function usePageChrome() {
  return useContext(PageChromeContext);
}
